var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.2 159",
    style: {
      enableBackground: "new 0 0 150.2 159"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.8,66H98.6c-10.2,0-18.4,8.3-18.4,18.4v56.7c0,10.2,8.2,18.4,18.4,18.4h33.1c10.2,0,18.4-8.2,18.4-18.4 V84.4C150.2,74.3,141.9,66,131.8,66z M115.3,127.5c-9.3,0-16.9-7.6-16.9-16.9c0-9.3,7.6-16.9,16.9-16.9c9.3,0,16.9,7.6,16.9,16.9 C132.2,120,124.6,127.5,115.3,127.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.9,0H96.5c-9,0-16.3,7.6-16.3,17v20.9c0,9.4,7.3,17,16.3,17h37.4c9,0,16.3-7.6,16.3-17V17 C150.2,7.6,142.9,0,133.9,0z M98.9,36.8l16.2-24.1l15.7,24.1H98.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,0.5H18c-10,0-18,8.1-18,18V74C0,84,8.1,92,18,92h33.9c10,0,18-8.1,18-18V18.5C70,8.6,61.9,0.5,51.9,0.5z  M48,57.5H21v-27h27V57.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,105.2H15.2c-8.4,0-15.2,7-15.2,15.5v22.7C0,152,6.8,159,15.2,159h39.6c8.4,0,15.2-7,15.2-15.5v-22.7 C70,112.1,63.1,105.2,54.8,105.2z M17,139.3l6.1-15.3h23.2l7.5,15.3H17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.4de6005d3dc72a6503fb264e5a8db96f.svg";
export { ForwardRef as ReactComponent };